<template>
  <v-footer app v-if="!hideFooter" dark height="auto" class="pa-0">
    <v-card class="flex" flat tile>
      <v-card-actions :class="footerColor">
        &copy;2025 —&nbsp;<strong>{{ getExpression('Label', 'AmbientAccess') }}</strong>&nbsp;{{
          appVersion
        }}
      </v-card-actions>
    </v-card>
  </v-footer>
</template>

<script>
import { AppColor, AppConfig } from '@/config.js'

export default {
  name: 'AppFooter',
  data() {
    return {
      footerColor: AppColor.Footer + ' justify-center'
    }
  },
  computed: {
    hideFooter () {
      return this.$route.name === 'Logout'
    },
    appVersion () {
      if (this.isSmallDevice) return ''
      switch (AppConfig.Mode) {
        case 'development':
          return '(Development)'
        case 'sandbox':
          return '(Sandbox)'
        case 'stage':
          return '(Stage)'
        case 'production':
          return '(Production)'
        default: return ''
      }
    }
  }
}
</script>
